import Card from "./card.js";
export default class ControlCard extends Card {
  constructor(t, s, l, i, r, n) {
    super(t, s, null, null, null, l, i, null, null, null, r, n),
      (this.isControl = !0),
      (this.ae = "ab-control-card"),
      (this.oe = !1);
  }
  bt() {
    const t = {};
    return (
      (t[Card.hs.ss] = Card.rs.Ni),
      (t[Card.hs.os] = this.id),
      (t[Card.hs.cs] = this.viewed),
      (t[Card.hs.us] = this.updated),
      (t[Card.hs.ls] = this.expiresAt),
      (t[Card.hs.bs] = this.extras),
      (t[Card.hs.gs] = this.pinned),
      (t[Card.hs.vs] = this.test),
      t
    );
  }
}
